export default "__VITE_ASSET__D11qL_Mo__"